function CTF() {
    return (<div>
        BAE Systems hosted a Capture the Flag competition, focusing on puzzle solving, cryptography, and web vulnerabilities. I was part of a team of 3 (one of the smallest teams) and we ended up finishing in first place. The competition was a lot of fun and had some fun challenges like writing programs for turing machines and installing wire taps on a network.
    </div>);
}

export default CTF;